module.exports = __webpack_public_path__ + "assets/videos/MOA_ru.mp4";